import { MetaData, SpecialistPage } from '@/components'

export default function NextSpecialistPage(props) {
  const { first_name, last_name, patronymic, position, qualification, meta } = props
  const { title: titleFromProps, description: descFromProps } = meta;
  const title = titleFromProps || `${last_name || ''} ${first_name || ''} ${patronymic || ''}. ${position || ''}. ${qualification || ''}`;
  const description = descFromProps
  return (
    <>
      <MetaData title={title} description={description} />
      <SpecialistPage {...props} />
    </>
  )
}

NextSpecialistPage.getInitialProps = async ({ query, api }) => {
  const { specialistSlug, ...otherQueries } = query

  const response = await api.specialist({ slug: specialistSlug, ...otherQueries })

  const { data } = response

  return { ...data }
}
